import React from "react";
import { Outlet } from "react-router-dom";
import { useAppContext } from "../../app/AppRootProviders";
import MerchantSidebar from "./MerchantSidebar";
import MerchantTopbar from "./MerchantTopbar";
import { TooltipProvider } from "../../components/tooltip";

interface MerchantDashboardLayoutProps {}

const MerchantDashboardLayout: React.FC<MerchantDashboardLayoutProps> = () => {
  const { sidebarOpen, setSidebarOpen, onLogout } = useAppContext();

  return (
    <div
      id="merchant-dashboard-layout"
      className="bg-muted/50 flex h-screen overflow-hidden"
    >
      {/* Merchant Sidebar */}
      <MerchantSidebar
        sidebarOpen={sidebarOpen}
        setSidebarOpen={setSidebarOpen}
        onLogout={onLogout}
      />

      {/* Main content */}
      <div className="flex-1 flex flex-col min-w-0 bg-white dark:bg-gray-900 overflow-y-auto">
        {/* Topbar */}
        <MerchantTopbar
          sidebarOpen={sidebarOpen}
          setSidebarOpen={setSidebarOpen}
          onLogout={onLogout}
        />

        {/* Content */}
        <main className="flex-1 max-h-[calc(100vh-64px)] overflow-y-auto">
          <TooltipProvider>
            <Outlet />
          </TooltipProvider>
        </main>
      </div>
    </div>
  );
};

export default MerchantDashboardLayout;
